import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ProviderConsentState {
  // Basic
  consentName: string;
  error: string;
  loading: boolean;
  formSubmitting: boolean;

  status: string;
  formDirty: boolean; // Unused X
  readonly: boolean;

  // Currently In Use
  blocks: any[];
  formId: string; //FormId
  studyId: string;
  // providerResponse: any;
}

export const initialQuestionState: ProviderConsentState = {
  // Basic
  consentName: "",
  error: "",
  loading: true,
  formSubmitting: false,

  status: "",
  formDirty: false, // Unused X
  readonly: true,
  // Currently In Use
  blocks: [],
  formId: "", //FormId
  studyId: "",
  // providerResponse: {},
};

export const providerConsentSlice = createSlice({
  name: "providerConsent",
  initialState: initialQuestionState,
  reducers: {
    reset: () => initialQuestionState,
    setConsentLoader: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setConsentSubmitting: (state, action: PayloadAction<boolean>) => {
      state.formSubmitting = action.payload;
    },
    setProviderResponse: (
      state,
      action: PayloadAction<{ blockId: string; response: Record<string, any> }>
    ) => {
      const { blockId, response } = action.payload;
      state.blocks.forEach((block) => {
        if (block.id === blockId) {
          block.response = response;
        }
      });
    },
    updateResponse: (
      state,
      action: PayloadAction<{ blockId: string; key: string; value: any }>
    ) => {
      const { blockId, key, value } = action.payload;
      state.blocks.forEach((block) => {
        if (block.id === blockId) {
          block.response[key] = value;
        }
      });
    },
    updateBlockEditable: (
      state,
      action: PayloadAction<{ blockId: string; editable: boolean }>
    ) => {
      const { blockId, editable } = action.payload;
      state.blocks.forEach((block) => {
        if (block.id === blockId) {
          block.editable = editable;
        }
      });
    },
    resetConsentState: (state) => {
      state.consentName = "";
      state.error = "";
      state.loading = true;
      state.formSubmitting = false;

      state.status = "";
      state.formDirty = false;

      state.blocks = [];
      state.formId = "";
      state.studyId = "";
      state.readonly = true;
      // state.providerResponse = {};
    },
    setConsentsDetails: (
      state,
      action: PayloadAction<ProviderConsentState>
    ) => {
      state.consentName = action.payload.consentName;
      state.error = action.payload.error;
      state.loading = action.payload.loading;
      state.formSubmitting = action.payload.formSubmitting;

      state.status = action.payload.status;
      state.formDirty = action.payload.formDirty;

      state.blocks = action.payload.blocks;
      state.formId = action.payload.formId;
      state.studyId = action.payload.studyId;
      state.readonly = action.payload.readonly;
      // state.providerResponse = action.payload.providerResponse;
    },
  },
});

export const {
  setConsentsDetails,
  setProviderResponse,
  setConsentLoader,
  updateResponse,
  updateBlockEditable,
  setConsentSubmitting,
  resetConsentState,
  reset,
} = providerConsentSlice.actions;

export default providerConsentSlice.reducer;
